import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import './PasswordReset.css';
import logo from '../../assets/logo-green.svg';

function PasswordRecovery() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    const auth = getAuth();
    try {
      await sendPasswordResetEmail(auth, email);
      setMessage(
        'Você receberá um link de recuperação de senha no seu e-mail.'
      );
      setTimeout(() => {
        navigate('/login');
      }, 5000);
    } catch (err) {
      console.error(err);
      setError('Ocorreu um erro ao tentar enviar o e-mail. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pr-container">
      <div className="pr-card">
        <div className="pr-logo-container">
          <img src={logo} alt="Plantão Fácil Logo" className="pr-logo" />
        </div>
        <h1 className="pr-title">Recuperar Senha</h1>
        <p className="pr-subtitle">
          Insira seu e-mail cadastrado para receber um link de redefinição de
          senha.
        </p>
        {error && (
          <p className="pr-error-message" aria-live="polite">
            {error}
          </p>
        )}
        {message && (
          <p className="pr-success-message" aria-live="polite">
            {message}
          </p>
        )}
        <form
          onSubmit={handleSubmit}
          className="pr-form"
          aria-labelledby="pr-title"
        >
          <div className="pr-input-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Digite seu email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              aria-required="true"
            />
          </div>
          <button type="submit" className="pr-button" disabled={loading}>
            {loading ? 'Enviando...' : 'Enviar Link de Recuperação'}
          </button>
        </form>
        <div className="pr-footer">
          <Link to="/login" className="pr-back-button">
            Voltar ao Login
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PasswordRecovery;
